<div class="full-100">
    @if (display === true) {
        @if (showPdf === true) {
        <div style="position: relative; width: 100%; height: 100%;">
            <pdf-preview style={{stylePdf}} [pathPdf]="pathPdf"></pdf-preview>
        </div>
        }
    }
</div>

